// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"253":"83d0b4de","260":"83d0b4de","341":"83d0b4de","467":"83d0b4de","478":"83d0b4de","861":"83d0b4de"}[chunkId] + ".chunk.css";
};